import React, { FC, RefObject } from 'react'
import { isTypeOfWorkSectionA, isTypeOfWorkSectionB } from './__index.utils'
import { CheckboxList, RadioList } from '@utils/request'
import * as utilsList from './__index.utils'
import CheckboxInput from '../inputs/checkbox.input'
import MeasurementInput from '../inputs/measurement.input'

const Step4_5LandDevelopmentWork = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		typesOfWorkDiverse,
		areaScreen,
		areaUnitScreen,
		areaOutdoorStorage,
		areaUnitOutdoorStorage
	} = formInputs

	const radioListTypesOfWorkDiverse: CheckboxList[] =
		utilsList.radioListTypesOfWorkDiverse(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	return (
		<>
			{/* typesOfWorkDiverseInput */}

			<CheckboxInput
				name={typesOfWorkDiverse.name}
				label={typesOfWorkDiverse.label}
				description={typesOfWorkDiverse.description}
				value={`${typesOfWorkDiverse.value}`}
				list={radioListTypesOfWorkDiverse}
				onChange={(value) => updateCheckBoxInput(typesOfWorkDiverse, value)}
				required={typesOfWorkDiverse.required}
				hasError={errors.includes(typesOfWorkDiverse.name)}
				ref={typesOfWorkDiverse.ref as RefObject<HTMLInputElement>}
				errors={errors}
				shouldNotDivide
				hasBackgroundWrapper
				onFixError={onFixError}
				newCheckValue
				isSummaryStep={isSummaryStep}
			/>

			{/* Section A */}
			{isTypeOfWorkSectionA(typesOfWorkDiverse.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{
							pageAssets?.request_form_landDevelopmentWorkPermit_isOutdoorStorage_acousticScreen
						}
					</h5>

					{/* areaBalconyInput */}
					<MeasurementInput
						measurementInput={areaScreen}
						unitInput={areaUnitScreen}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(areaScreen.name)}
						reducedMargin
						disableWarningTooltip
					/>
				</>
			)}

			{/* Section B  */}
			{isTypeOfWorkSectionB(typesOfWorkDiverse.value) && (
				<>
					<h5 className={pageUtils.classes.h5}>
						{
							pageAssets?.request_form_landDevelopmentWorkPermit_isOutdoorStorage_outdoorStorage
						}
					</h5>

					<MeasurementInput
						measurementInput={areaOutdoorStorage}
						unitInput={areaUnitOutdoorStorage}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(areaOutdoorStorage.name)}
						reducedMargin
						disableWarningTooltip
					/>
				</>
			)}
		</>
	)
}

export default Step4_5LandDevelopmentWork
